module.exports = __webpack_public_path__ + "img/icon2.3282c67b.png";